export type ThemePreference = "auto" | "light" | "dark";

const storageKey = "cowdiff:theme";
const darkScheme = "(prefers-color-scheme: dark)";

export function storedTheme(): ThemePreference {
  try {
    const theme = localStorage.getItem(storageKey);
    return theme === "light" || theme === "dark" ? theme : "auto";
  } catch {
    return "auto";
  }
}

export function resolvedTheme(theme: ThemePreference): "light" | "dark" {
  if (theme !== "auto") return theme;
  return window.matchMedia(darkScheme).matches ? "dark" : "light";
}

export function applyTheme(theme: ThemePreference) {
  const resolved = resolvedTheme(theme);
  document.documentElement.dataset.theme = resolved;
  document.documentElement.dataset.themePreference = theme;
  document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]').forEach((meta) => {
    meta.content = resolved === "dark" ? "#171816" : "#f3f0e8";
  });
}

export function saveTheme(theme: ThemePreference) {
  try {
    if (theme === "auto") localStorage.removeItem(storageKey);
    else localStorage.setItem(storageKey, theme);
  } catch {
    // The choice still applies for this session when storage is unavailable.
  }
}

export function systemThemeQuery(): MediaQueryList {
  return window.matchMedia(darkScheme);
}
